const styles = (theme) => ({
  signInBg: {
    backgroundImage:
      'url("//target.scene7.com/is/image/Target/assethub-homepage-image?cropN=0.3,0.2,0.4,0.8&wid=600&qlt=100")',
    minHeight: '100vh',
  },
})

export default styles
